/** @file Fills each skinned mesh record's `skin` through the skinning stage, copying instead of mutating. */
import type { Doc, Pose2DJson } from '@pose2d/format/types';
import type { CompileStages } from './compileStages';

type Compiled = { attachments: Pose2DJson['attachments']; attachmentIndex: ReadonlyMap<string, number> };

/**
 * A new attachment array: every skinned mesh record is replaced by a copy with `skin = skinning(mesh, boneIndex)`
 * (one stage call per skinned mesh, W2-18); every other record is shared. `compiled` is never mutated.
 */
export function attachSkins(doc: Doc, compiled: Compiled, boneIndex: Map<string, number>, skinning: CompileStages['skinning']): Pose2DJson['attachments'] {
  const out = [...compiled.attachments];
  for (const [id, att] of Object.entries(doc.attachments)) {
    if (att.type !== 'mesh' || att.geometry.kind !== 'skinned') continue;
    const i = compiled.attachmentIndex.get(id) ?? -1;
    const record = out[i];
    if (record?.type !== 'mesh') continue;
    out[i] = { ...record, skin: skinning(att, boneIndex) };
  }
  return out;
}
